import { NextPage } from 'next';
import React from 'react';
import { PrivacyPolicyContent } from 'containers/privacy';

const PrivacyPolicy: NextPage = () => {
  return (
    <>
      <PrivacyPolicyContent />
    </>
  );
};

export default PrivacyPolicy;
